import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { motion } from "motion/react";

interface LoadingSpinnerProps {
  width: number;
  height: number;
}

export const LoadingAtom = ({ width, height }: LoadingSpinnerProps) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      style={{
        filter: "hue-rotate(20deg)",
      }}
    >
      <DotLottieReact
        src="/assets/images/loading.lottie"
        loop
        autoplay
        width={width}
        height={height}
        style={{
          width: `${width}px`,
          height: `${height}px`,
        }}
      />
    </motion.div>
  );
};

export default LoadingAtom;
